/** Reloads the page once the hub runs a newer build than the one that served it. */

const CHECK_MS = 60_000

export const watchVersion = () => {
  const served = document.querySelector<HTMLMetaElement>('meta[name="commit"]')?.content
  if (!served) return
  const check = async () => {
    const health: unknown = await fetch("/health", { cache: "no-store" }).then((r) => r.json()).catch(() => null)
    const commit = typeof health === "object" && health !== null && "commit" in health ? health.commit : null
    if (typeof commit === "string" && commit !== served) location.reload()
  }
  setInterval(() => {
    if (document.visibilityState === "visible") void check()
  }, CHECK_MS)
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") void check()
  })
}
